import React, {Component} from 'react';

import cl from 'classnames';
import s from './Cover.css';

class Cover extends Component {
  state = {
    visible: true
  };

  componentWillReceiveProps(props) {
    const {src} = this.props;

    if (src !== props.src) {
      this.setState({
        visible: false
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.onLoad();
    }
  }

  onLoad = () => {
    this.setState(
      {
        visible: true
      },
      () => {
        const {onLoad} = this.props;
        if (onLoad) {
          onLoad();
        }
      }
    );
  };

  onError = () => {
    this.setState({
      visible: null
    });
  };

  render() {
    const {visible} = this.state;
    const {id, src, color, className} = this.props;

    const style = {
      backgroundColor: color
    };
    const imageStyle = {
      filter: `url(#coverFilter-${id})`
    };

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={cl(s.Cover, className)}
        style={style}
      >
        <defs>
          <filter id={'coverFilter-' + id}>
            <feFlood
              result="floodFill"
              x="0"
              y="0"
              width="100%"
              height="100%"
              floodColor={color}
              floodOpacity="1"
            />
            <feBlend in="SourceGraphic" in2="floodFill" mode="multiply" />
          </filter>
        </defs>

        {visible && (
          <image
            xlinkHref={src}
            x="0"
            y="0"
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMax"
            style={imageStyle}
            className={cl(s.Image)}
            onError={this.onError}
          />
        )}
      </svg>
    );
  }
}

export {Cover};
